<template>
  <Transition name="fade">
    <div v-if="bannerList.length">
      <el-carousel :interval="5000" style="height: 130px">
        <el-carousel-item
          style="height: 130px"
          v-for="item in bannerList"
          :key="item.bannerID"
        >
          <a :href="item.bannerUrl"
            ><img
              style="border-radius: 5px; height: 130px"
              v-lazy="item.bannerImg"
              :alt="item.bannerDesc"
          /></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <NewCarouselSkeleton v-else />
  </Transition>
</template>

<script>
import NewCarouselSkeleton from "../common/new-carousel-skeleton.vue";
export default {
  components: {
    NewCarouselSkeleton,
  },
  props: {
    bannerList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
